import { render } from "./viewPlansComponent.vue?vue&type=template&id=aff0fb0e"
import script from "./viewPlansComponent.vue?vue&type=script&lang=js"
export * from "./viewPlansComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__